<template>
  <v-sheet
    color="grey lighten-4"
    class="pt-8 pt-md-12 pt-lg-16 pb-8 pb-md-12 pb-lg-16"
    v-if="culture || gallery || article || video"
  >
    <Title>Sala de Imprensa</Title>

    <v-container class="mt-6 mt-md-8 mt-lg-10 mb-md-6">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="5" lg="3" v-if="culture">
          <v-card
            color="white"
            to="/projetos/espaco-cultural"
            class="d-flex flex-column item"
            height="100%"
            tile
          >
            <div class="relative">
              <img
                :src="files + culture.featured"
                alt="Exposições"
                class="d-block item-img"
              />
              <v-sheet
                width="48px"
                height="48px"
                color="white"
                class="
                  d-flex
                  align-center
                  justify-center
                  rounded-pill
                  item-icon
                "
              >
                <v-sheet
                  width="38px"
                  height="38px"
                  color="primary"
                  class="d-flex align-center justify-center rounded-pill"
                >
                  <v-icon color="white" size="18"> fa-camera </v-icon>
                </v-sheet>
              </v-sheet>
            </div>

            <div
              class="
                text-h6
                grey--text
                text--darken-3
                font-weight-medium
                text-center
                px-4
                py-7
              "
            >
              Espaço Cultural
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="5" lg="3" v-if="gallery">
          <v-card
            color="white"
            to="/imprensa/galerias-de-fotos"
            class="d-flex flex-column item"
            height="100%"
            tile
          >
            <div class="relative">
              <img
                :src="files + gallery"
                alt="Fotos e Eventos"
                class="d-block item-img"
              />
              <v-sheet
                width="48px"
                height="48px"
                color="white"
                class="
                  d-flex
                  align-center
                  justify-center
                  rounded-pill
                  item-icon
                "
              >
                <v-sheet
                  width="38px"
                  height="38px"
                  color="primary"
                  class="d-flex align-center justify-center rounded-pill"
                >
                  <v-icon color="white" size="18"> fa-images </v-icon>
                </v-sheet>
              </v-sheet>
            </div>

            <div
              class="
                text-h6
                grey--text
                text--darken-3
                font-weight-medium
                text-center
                px-4
                py-7
              "
            >
              Fotos e Eventos
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="5" lg="3" v-if="article">
          <v-card
            color="white"
            to="/imprensa/noticias"
            class="d-flex flex-column item"
            height="100%"
            tile
          >
            <div class="relative">
              <img
                :src="files + article"
                alt="Notícias e Releases"
                class="d-block item-img"
              />
              <v-sheet
                width="48px"
                height="48px"
                color="white"
                class="
                  d-flex
                  align-center
                  justify-center
                  rounded-pill
                  item-icon
                "
              >
                <v-sheet
                  width="38px"
                  height="38px"
                  color="primary"
                  class="d-flex align-center justify-center rounded-pill"
                >
                  <v-icon color="white" size="18"> fa-newspaper </v-icon>
                </v-sheet>
              </v-sheet>
            </div>

            <div
              class="
                text-h6
                grey--text
                text--darken-3
                font-weight-medium
                text-center
                px-4
                pt-8
                pb-7
              "
            >
              Notícias e Releases
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="5" lg="3" v-if="video">
          <v-card
            color="white"
            to="/imprensa/videos"
            class="d-flex flex-column item"
            height="100%"
            tile
          >
            <div class="relative">
              <img
                :src="`//img.youtube.com/vi/${getYoutubeCode(
                  video
                )}/mqdefault.jpg`"
                alt="Vídeos"
                class="d-block item-img"
              />
              <v-sheet
                width="48px"
                height="48px"
                color="white"
                class="
                  d-flex
                  align-center
                  justify-center
                  rounded-pill
                  item-icon
                "
              >
                <v-sheet
                  width="38px"
                  height="38px"
                  color="primary"
                  class="d-flex align-center justify-center rounded-pill"
                >
                  <v-icon color="white" size="18"> fa-video </v-icon>
                </v-sheet>
              </v-sheet>
            </div>

            <div
              class="
                text-h6
                grey--text
                text--darken-3
                font-weight-medium
                text-center
                px-4
                py-7
              "
            >
              Vídeos
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { getYoutubeCode } from "../../../utils/getYoutubeCode";
import Title from "../../widgets/Title.vue";

export default {
  computed: {
    culture() {
      return this.$rest("cultural-space-galleries").item.img;
    },
    gallery() {
      return this.$rest("galleries").item.img;
    },
    article() {
      return this.$rest("articles").item.img;
    },
    video() {
      return this.$rest("videos").item.video;
    },
  },
  mounted() {
    this.$rest("cultural-space-galleries").get({
      params: { itemsPerPage: 1 },
      save: (state, data) => (state.item = data[0]),
    });

    this.$rest("galleries").get({
      params: { itemsPerPage: 1 },
      save: (state, data) => (state.item = data[0]),
    });

    this.$rest("articles").get({
      params: { itemsPerPage: 1 },
      save: (state, data) => (state.item = data[0]),
    });

    this.$rest("videos").get({
      params: { itemsPerPage: 1 },
      save: (state, data) => (state.item = data[0]),
    });
  },
  methods: {
    getYoutubeCode,
  },
  components: {
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  box-shadow: 0px 8px 16px -5px rgba(30, 46, 56, 0.1) !important;
  .item-img {
    aspect-ratio: 16 / 12;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-icon {
    left: 50%;
    margin-left: -24px;
    margin-top: -24px;
    position: absolute;
    top: 100%;
  }
}
</style>
